import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueGeolocationApi from 'vue-geolocation-api'

import VueTypedJs from 'vue-typed-js'

Vue.use(VueTypedJs)

Vue.use(VueGeolocationApi)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
